// root '../../../';

// dependencies
import { Child } from 'pym.js';
import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)


// styles
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';

const d3 = require('d3');

d3.timeFormatDefaultLocale({
  periods: ['a.m.', 'p.m.'],
  days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  shortMonths: ['Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'],
});


const mapboxgl = require('mapbox-gl');
const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}


// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

mapboxgl.accessToken = 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJja2V1M3Vyd3kwMDZrMnF0Njdhb3ZhZDk5In0.OURIYzTcS6ZzoWjXJzfANg';

const isMobile = window.innerWidth < 500;


const bounds = isMobile ? [[52.5, 23], [60, 28]] : [[52.5, 23], [60, 28]];

const map = new mapboxgl.Map({
  container: 'hormuz-ship-tracker-map',
  style: 'mapbox://styles/cnndigital/cl960ytee001215qu1uhorjlx',
  bounds,
  maxZoom: 10,
  bearing: 0,
  scrollZoom: false,
  dragRotate: false,
  touchPitch: false,
  interactive: true,
  maxBounds: bounds,
  projection: 'mercator',
});

map.dragRotate.disable();
map.touchZoomRotate.disableRotation();

if (!isMobile) {
  const nav = new mapboxgl.NavigationControl({
    showCompass: false,
  });
  map.addControl(nav, 'bottom-right');
}

window.addEventListener('resize', () => {
  map.fitBounds(bounds);
  pymChild.sendHeight();
});


map.on('load', async () => {
  // Hide the default Iran label and place a custom one within the visible bounds
  const countryLabelLayer = map.getStyle().layers.find(
    l => l.type === 'symbol' && l.id.toLowerCase().includes('country-label'),
  );


  map.addSource('iran-label', {
    type: 'geojson',
    data: {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [55, 27.5] },
      properties: {
        name: 'Iran',
      },
    },
  });

  map.addLayer({
    id: 'iran-label',
    type: 'symbol',
    source: 'iran-label',
    layout: {
      'text-field': 'Iran',
      'text-size': 17,
      'text-transform': 'uppercase',
      'text-letter-spacing': 0.15,
      'text-font': ['CNN Sans Display Medium'],
    },
    paint: {
      'text-color': '#262626',
      'text-halo-color': '#fff',
      'text-halo-width': 1,
    },
  });

  map.addSource('oman-label', {
    type: 'geojson',
    data: {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [56.46, 23.8] },
      properties: {
        name: 'Oman',
      },
    },
  });

  map.addLayer({
    id: 'oman-label',
    type: 'symbol',
    source: 'oman-label',
    layout: {
      'text-field': 'Oman',
      'text-size': 15,
      'text-transform': 'uppercase',
      'text-letter-spacing': 0,
      'text-font': ['CNN Sans Display Medium'],
    },
    paint: {
      'text-color': '#262626',
      'text-halo-color': '#fff',
      'text-halo-width': 1,
    },
  });

  map.addSource('strait-of-hormuz-label', {
    type: 'geojson',
    data: {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [56.54232990376979, 26.67975554440772] },
      properties: {
        name: 'Strait of Hormuz',
      },
    },
  });

  map.addLayer({
    id: 'strait-of-hormuz-label',
    type: 'symbol',
    source: 'strait-of-hormuz-label',
    layout: {
      'text-field': 'Strait of Hormuz',
      'text-size': 13,
      'text-max-width': 5,
      'text-transform': 'uppercase',
      'text-letter-spacing': 0,
      'text-font': ['CNN Sans Display Italic'],
    },
    paint: {
      'text-color': '#6e6e6e',
      'text-halo-color': '#fff',
      'text-halo-width': 1,
    },
  });


  const rawData = 'https://ix.cnn.io/data/hormuz-marine-traffic/hormuz_marine_traffic.json';
  const countryCodeLookup = 'https://ix.cnn.io/data/hormuz-marine-traffic/unlocode.json';

  let geojson;

  try {
    const raw = await fetch(rawData).then(r => r.text());
    const countryCodes = await fetch(countryCodeLookup).then(r => r.json());

    const data = JSON.parse(raw.replace(/:\s*NaN/g, ': null'));

    console.log(data.lastUpdatedStr);
    // const updateTime = d3.timeParse('%Y-%m-%dT%H:%M:%S%Z')(`${data.lastUpdatedStr}`);
    const updateTime = (data.lastUpdatedStr);

    d3.select('#timestamp')
      .text(`Data as of ${(updateTime)}.`);

    console.log(updateTime);
    geojson = {
      type: 'FeatureCollection',
      features: data.data_24h.map(item => ({
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [item.longitude, item.latitude] },
        properties: {
          ...item,
          countryName: countryCodes[item.flag] || item.flag,
        },
      })),
    };
  } catch (err) {
    console.error('Failed to load ship data:', err);
    return;
  }

  // Preload flag images for all unique flags in the data
  const uniqueFlags = [...new Set(
    geojson.features
      .map(f => f.properties.flag)
      .filter(Boolean)
      .map(f => f.toLowerCase()),
  )];
  uniqueFlags.forEach((flag) => {
    const img = new Image();
    img.src = `https://ix.cnn.io/assets/flags/${flag}.svg`;
  });

  // Load the geojson data into the map
  map.addSource('hormuz-ship-tracker', {
    type: 'geojson',
    data: geojson,
    generateId: true,
  });

  // Add the ships to the map
  const point_size = 4;
  const point_multiplier = 0.6;

  map.addLayer({
    id: 'ships-layer',
    type: 'circle',
    source: 'hormuz-ship-tracker',
    paint: {
      'circle-radius': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        point_size * 2, // Larger radius on hover
        point_size, // Default radius
      ],
      'circle-color': '#7c4ea5',
      'circle-stroke-width': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        1, // Larger radius on hover
        0.5, // Default radius
      ],
      'circle-stroke-color': '#ffffff',
    },
    filter: ['!=', 'vesselCategory', 'Other'],
  }, 'waterway-label');


  let hoveredShipName = null;
  let hoveredShipCategory = null;
  let hoveredShipCountryName = null;
  let hoveredShipFlag = null;
  let hoveredShipId = null;
  let hoveredShipUpdated = null;
  let hoveredShipFlagIcon = null;

  function formatHoursSinceLastUpdate(hours) {
    if (hours < 1) {
      return 'Updated less than 1 hour ago';
    } if (hours < 2) {
      return 'Updated 1 hour ago';
    }
    return `Updated ${hours.toFixed(0).replace(/\.0+$/, '')} hour${hours > 1 ? 's' : ''} ago`;
  }

  function capitalizeFirstLetter(string) {
    const ch1 = string.charAt(0).toUpperCase();
    const rest = string.slice(1).toLowerCase();
    const result = ch1 + rest;
    return result.replace('Lpg', 'LPG');
  }

  map.on('mousemove', 'ships-layer', (e) => {
    if (e.features.length > 0) {
      if (hoveredShipId !== null) {
        map.setFeatureState(
          { source: 'hormuz-ship-tracker', id: hoveredShipId },
          { hover: false },
        );
      }
      hoveredShipId = e.features[0].id;
      map.setFeatureState(
        { source: 'hormuz-ship-tracker', id: hoveredShipId },
        { hover: true },
      );

      hoveredShipName = e.features[0].properties.vesselName;
      hoveredShipCategory = e.features[0].properties.vesselType;
      hoveredShipCountryName = e.features[0].properties.countryName;
      hoveredShipFlag = e.features[0].properties.flag;
      hoveredShipFlagIcon = `fi fi-${hoveredShipFlag.toLowerCase()}`;
      hoveredShipUpdated = d3.timeFormat('%b. %-d, %Y at %I:%M %p ET')(d3.timeParse('%Y-%m-%dT%H:%M:%S%Z')(e.features[0].properties.posDt)).replace(/am|pm/, match => `${match.charAt(0)}.m.`);

      // hours since last update
      const hoursSinceLastUpdate = formatHoursSinceLastUpdate((new Date() - d3.timeParse('%Y-%m-%dT%H:%M:%S%Z')(e.features[0].properties.posDt)) / (1000 * 60 * 60));

      map.getCanvas().style.cursor = 'pointer';
      const mapWidth = map.getCanvas().offsetWidth;
      const isNearRight = e.point.x > mapWidth - 175;
      d3.select('#tooltip').style('opacity', '1');
      d3.select('#tooltip').style('top', `${e.point.y + 10}px`);
      d3.select('#tooltip').style('left', `${e.point.x + (isNearRight ? -10 : 10)}px`);
      d3.select('#tooltip').classed('offset', isNearRight);

      d3.select('#hovered-ship-flag').style('background-image', `url(https://ix.cnn.io/assets/flags/${hoveredShipFlag.toLowerCase()}.svg)`);
      d3.select('#hovered-ship-name').html(`${hoveredShipName}`);
      d3.select('#hovered-ship-country-name').html(`${hoveredShipCountryName}`);
      d3.select('#hovered-ship-category').html(capitalizeFirstLetter(hoveredShipCategory));
      d3.select('#hovered-ship-updated').html(hoursSinceLastUpdate);
    }
  });

  map.on('mouseleave', 'ships-layer', () => {
    if (hoveredShipId !== null) {
      map.setFeatureState(
        { source: 'hormuz-ship-tracker', id: hoveredShipId },
        { hover: false },
      );
    }
    hoveredShipId = null;
    map.getCanvas().style.cursor = '';
    d3.select('#tooltip').style('opacity', '0');
  });

  pymChild.sendHeight();
});
